/* eslint-disable no-underscore-dangle */
import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import SpecialPropsIndicators from '../props-Indicator/special-props';
import { assignFormDesignToCSSVars } from '../fields-customise.style';
import { FormContext } from '../../../shared/contexts/form-context';
import { ctrlDefaults } from '../../../../shared/form-lib';
import { selectCtrlIdLabelMap } from '../../selectors';
import { ControlPropType } from '../../ctrl_proptype';
import MatrixTable from './matrix_table';
import {
  ValidationWarning,
  MainfieldWrapper,
  SubtextWrapper,
  FieldWrapper,
  LabelWrapper,
  InputWrapper,
  Field,
} from '../../common-field-styles';

const MatrixRating = ({ ctrl, formDesign }) => {
  const { inBuilder } = useContext(FormContext);
  const [ctrlValidationError, setCtrlValidationError] = useState(ctrl._validationError ?? '');
  const ctrlIdLabelMap = useSelector(selectCtrlIdLabelMap);
  const fieldLabel = ctrlIdLabelMap?.[ctrl.internal_id];

  useEffect(() => {
    setCtrlValidationError(ctrl._validationError);
  }, [ctrl._validationError]);

  return (
    <MainfieldWrapper style={assignFormDesignToCSSVars(inBuilder, formDesign)}>
      <FieldWrapper>
        {ctrlValidationError && (
          <ValidationWarning className="ui bottom pointing basic label red">{ctrlValidationError}</ValidationWarning>
        )}

        <Field>
          <LabelWrapper required={ctrl.props.required} notInBuilder={!inBuilder}>
            <label dangerouslySetInnerHTML={{ __html: fieldLabel || ctrlDefaults()[ctrl.type] }} />
            <SpecialPropsIndicators ctrl={ctrl} />
          </LabelWrapper>

          <InputWrapper>
            <MatrixTable ctrl={ctrl} setCtrlValidationError={setCtrlValidationError} />

            <SubtextWrapper id="descriptive text" notInBuilder={!inBuilder}>
              {ctrl.props.subtext}
            </SubtextWrapper>
          </InputWrapper>
        </Field>
      </FieldWrapper>
    </MainfieldWrapper>
  );
};

MatrixRating.defaultProps = {
  formDesign: null,
};

MatrixRating.propTypes = {
  ctrl: PropTypes.shape(ControlPropType).isRequired,
  formDesign: PropTypes.shape({
    old: PropTypes.object.isRequired,
    design: PropTypes.object.isRequired,
  }),
};

export default MatrixRating;
